import clsx from 'clsx'
import { KTSVG } from '../../../helpers'
import { HeaderUserMenu } from '../../../partials'
import { useLayout} from '../../core'
import { useAuth } from '../../../../app/modules/auth'

const itemClass = 'ms-1 ms-lg-3'
const userAvatarClass = 'symbol-35px symbol-md-40px'
const btnIconClass = 'svg-icon-1'


const Navbar = () => {
  const {config} = useLayout()
  const { currentUser } = useAuth();
  return (
    <div className='app-navbar flex-shrink-0'>
      
      <div className={clsx('app-navbar-item', itemClass)}>
        { currentUser && 
        <div
            className={clsx('cursor-pointer symbol', userAvatarClass)}
            data-kt-menu-trigger="{default: 'click'}"
            data-kt-menu-attach='parent'
            data-kt-menu-placement='bottom-end'
        >
            <div className='symbol symbol-square symbol-40px overflow-hidden me-3'>
                <div className='symbol-label'>
                    <KTSVG
                        path='/media/icons/duotune/communication/com013.svg'
                        className={'svg-icon-3x ' + (currentUser && currentUser.isSetsco ? 'svg-icon-danger' : 'svg-icon-primary')}                    
                    />
                </div>                    
            </div>          
        </div>
        }        
        <HeaderUserMenu />
      </div>

      {config.app?.header?.default?.menu?.display && (
        <div className='app-navbar-item d-lg-none ms-2 me-n3' title='Show header menu'>
          <div
            className='btn btn-icon btn-active-color-primary w-35px h-35px'
            id='kt_app_header_menu_toggle'
          >
            <KTSVG path='/media/icons/duotune/text/txt001.svg' className={btnIconClass} />
          </div>
        </div>
      )}
    </div>
  )
}

export {Navbar}
